import { ActivityLogTab } from "@features/ax/shared/ActivityLog";
import { NotesTab } from "@features/ax/shared/NotesTab";
import { Tabs } from "@shared/ui/tabs";
import {
  FileSearch,
  FileText,
  History,
  Package,
  StickyNote,
} from "lucide-react";
import React, { useMemo } from "react";
import { ScheduleAssetsTab } from "./tabs/ScheduleAssetTab";
import { ScheduleDetailsTab } from "./tabs/ScheduleDetailsTab";
import { ScheduleHistoryTab } from "./tabs/ScheduleHistoryTab";

export const ScheduleTabs: React.FC<any> = ({ data }) => {
  // Create tab components with stable references
  const source = "6";
  const tabComponents = useMemo(() => {
    return {
      details: {
        label: "Details",
        icon: <FileText className="h-4 w-4" />,
        component: (
          <ScheduleDetailsTab
            key={`details-${data?.id}`}
            scheduleId={data?.id}
            data={data}
          />
        ),
      },
      assets: {
        label: "Assets",
        icon: <Package className="h-4 w-4" />,
        component: (
          <ScheduleAssetsTab key={`assets-${data?.id}`} scheduleId={data?.id} />
        ),
      },
      history: {
        label: "History",
        icon: <History className="h-4 w-4" />,
        component: (
          <ScheduleHistoryTab
            key={`history-${data?.id}`}
            scheduleId={data?.id}
          />
        ),
      },
      notes: {
        label: "Notes",
        icon: <StickyNote className="h-4 w-4" />,
        component: (
          <NotesTab requestId={data?.id} source={source} title="Schedule" />
        ),
      },
      logs: {
        label: "Logs",
        icon: <FileSearch className="h-4 w-4" />,
        component: <ActivityLogTab entityId={data?.id} entityType={source} />,
      },
    };
  }, [data?.id, source]);

  return (
    <Tabs
      defaultValue="details"
      className="w-full"
      urlMapping={{
        details: "details",
        assets: "assets",
        history: "history",
        notes: "notes",
        logs: "logs",
      }}
      disableUrlSync={false}
      idPrefix="schedule"
      tabComponents={tabComponents}
      tabsListClassName="grid w-full grid-cols-5"
    />
  );
};
